// @TODO: if touch is close to an edge, the popover will be cut off
// @TODO: this should use safeAreaInsets
/**
 * Ryan O'Dowd
 * 2024-11-11
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({globalScale, colors, windowWidthRaw, windowWidth, windowHeight, touchPosn}) => {
  const VERTICAL_OFFSET = 16;
  const HORIZONTAL_OFFSET = -32;
  const borderWidth = globalScale * 4;
  const arrowSize = VERTICAL_OFFSET + borderWidth;
  const minPadding = globalScale * 8;
  const MAX_WIDTH = 350;

  const windowStartX = (windowWidthRaw - windowWidth) / 2;
  const touchOffsetFromStartX = touchPosn.x - windowStartX;
  const isRightHalf = touchPosn.x >= (windowWidthRaw / 2);
  const remainingSpace = isRightHalf ? touchOffsetFromStartX : windowWidth - touchOffsetFromStartX;
  const wrapperMaxWidth = remainingSpace - HORIZONTAL_OFFSET - minPadding;

  // @TODO: arrow has gap depending on the screen...chatmessage difference from footnotes, for example...don't like this hardcoded 2
  let quandrantArrowStyles: any = { // assume quadrant 1 or 2
    top: touchPosn.y + borderWidth + 2, // @TODO: think i need this extra because of rounding due to globalScale...but it's weird that it's 2 on mobile and 1 on web
  };
  if (touchPosn.y >= (windowHeight / 2)) {
    // quadrant 3 or 4
    quandrantArrowStyles = {
      top: touchPosn.y - arrowSize + borderWidth + 0, // @TODO: looks okay, but calculation seems wrong
    };
  }

  const topOffset = touchPosn.y + VERTICAL_OFFSET;
  const rightOffset = (windowWidthRaw - touchPosn.x) + HORIZONTAL_OFFSET;
  const bottomOffset = (windowHeight - touchPosn.y) + VERTICAL_OFFSET;
  const leftOffset = touchPosn.x + HORIZONTAL_OFFSET;

  let quadrantPopoverStyles: any = { // assume quadrant 2
    top: topOffset,
    // @TODO: right: minPadding,
    // @TODO: bottom: minPadding,
    left: leftOffset,
  };
  if (touchPosn.y < (windowHeight / 2)) {
    if (touchPosn.x > (windowWidthRaw / 2)) {
      // quadrant 1
      quadrantPopoverStyles = {
        top: topOffset,
        right: rightOffset,
        // @TODO: bottom: minPadding,
        // @TODO: left: minPadding,
      };
    }
  } else {
    if (touchPosn.x < (windowWidthRaw / 2)) {
      // quadrant 3
      quadrantPopoverStyles = {
        // @TODO: top: minPadding,
        // @TODO: right: minPadding,
        bottom: bottomOffset,
        left: leftOffset,
      };
    } else {
      // quadrant 4
      quadrantPopoverStyles = {
        // @TODO: top: minPadding,
        right: rightOffset,
        bottom: bottomOffset,
        // @TODO: left: minPadding,
      };
    }
  }

  return {
    actionsWrapper: {
      marginHorizontal: 12,
      marginBottom: 12,
    },
    popoverButton: {
      marginTop: 8,
    },
    popoverWrapper: {
      position: 'absolute',
      ...quadrantPopoverStyles,
      backgroundColor: colors.popoverBg,
      width: 'max-content', // @TODO: work on mobile?
      maxWidth: Math.min(wrapperMaxWidth, MAX_WIDTH),
      borderRadius: globalScale * 20,
      borderWidth,
      borderColor: colors.primary,
    },
    arrow: {
      position: 'absolute',
      ...quandrantArrowStyles,
      left: touchPosn.x - (arrowSize / 2),
      width: arrowSize,
      height: arrowSize,
      transform: [{scale: globalScale}],
    },
    absoluteFill: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: windowWidthRaw,
      height: windowHeight,
      backgroundColor: `${colors.primaryExtraDark}77`,
    },
  };
};

export default getStyles;
